import { baseURL } from "../Config";
import axios from "axios";
import { toast } from "react-toastify";
import { trimData } from "../utilities/TrimPayloadData";

export const handlePutRequest = async (data, url) => {
    if (!navigator.onLine) {
        // Handle the case when the network is off
        toast.error("No internet connection. Please check your network and try again.");
        return;
    }
    const id = toast.loading("Please wait...");

    data = trimData(data);

    try {
        // const userToSend = "zbiz";
        // const passToSend = "@zbiz!123";
        // const encryptedUsername = handleEncryptData(userToSend);
        // const encryptedPassword = handleEncryptData(passToSend);
        const response = await axios({
            method: "put",
            url: `${baseURL + url}`,
            data: data,
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token"),
                // username: encryptedUsername,
                // password: encryptedPassword
            },
        });
        toast.update(id, { render: response.data.messages, type: "success", isLoading: false, autoClose: 3000 });
        return response.data;
    } catch (error) {
        if (error?.response?.data?.message === 'Session Expired') {
            console.log('error.response.data.messages', error.response.data.messages)
            localStorage.clear();
            setTimeout(() => {
                window.location.href = '/';
            }, 1000);
        }
        if (error.response.status === 500) toast.update(id, { render: error.response.data.messages || "Something went wrong !!", type: "error", isLoading: false, autoClose: 3000 });
        else if (error.response.status === 400) toast.update(id, { render: error?.response?.data?.[0]?.toastError || "Something went wrong !!", type: "error", isLoading: false, autoClose: 3000 });
        else toast.update(id, { render: error.response.data.message || "Something went wrong !!", type: "warn", isLoading: false, autoClose: 3000 });

        return error.response;
    }
};
